import script from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"

export default script